import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface SidebarSkeletonProps {
  collapsed: boolean;
}

export const SidebarSkeleton: React.FC<SidebarSkeletonProps> = ({ collapsed }) => {
  return (
    <div className="space-y-2 px-2 py-2">
      {Array.from({ length: collapsed ? 6 : 4 }).map((_, index) => (
        <div key={index} className={`flex items-center ${collapsed ? 'justify-center' : 'space-x-3'}`}>
          <Skeleton className={`${collapsed ? 'h-8 w-8' : 'h-6 w-6'} rounded bg-brand-primary/10`} />
          {!collapsed && <Skeleton className="h-4 flex-1 rounded bg-brand-primary/10" />}
        </div>
      ))}
    </div>
  );
};